import type { UserHomeActivityCardData } from '../user-home/components/ActivityCard';
import type { AgendaItem, AgendaOnlineItem } from './types';

type Translate = (key: string, params?: Record<string, string | number | boolean | null | undefined>, fallback?: string) => string;

/**
 * Transforme un item du read-model agenda en données de carte
 * (UserHomeActivityCardData), en reproduisant la logique de badges/détails
 * de GasCardRenderer::createActivityCardData côté PHP.
 */
export function agendaItemToCard(item: AgendaItem, t: Translate): UserHomeActivityCardData {
    const imageBadges = [{ text: item.type_label, type: 'default' }];
    if (item.is_free) {
        imageBadges.unshift({ text: t('agenda.badge.free', {}, 'Gratuit'), type: 'success' });
    }
    if (item.parent) {
        imageBadges.push({ text: item.parent.title, type: 'info' });
    }

    const metaBadges: Array<{ text: string; type: string }> = [];
    if (item.learning_pass_eligible) {
        metaBadges.push({ text: t('agenda.badge.learning_pass', {}, 'Pass d’abonnement'), type: 'warning' });
    }
    if (item.prerequis_parent) {
        metaBadges.push({ text: t('agenda.badge.prerequis_parent', {}, 'Activité de base requise'), type: 'danger' });
    }

    const details: Array<{ icon?: string; text?: string; html?: boolean }> = [
        { icon: '📅', text: item.date_label },
    ];
    if (item.duration_label) {
        details.push({ icon: '⏱️', text: item.duration_label });
    }
    if (item.animators_label) {
        details.push({ icon: '👤', text: item.animators_label });
    }
    const priceHtml = item.is_free
        ? `<strong>${t('agenda.price.free', {}, 'Gratuit')}</strong>`
        : t('agenda.price.from', { amount: item.price_from }, `Dès ${item.price_from} CHF`);
    details.push({ icon: '💰', text: priceHtml, html: true });

    return {
        id: item.id,
        title: item.title,
        url: item.url,
        image_url: item.image_url,
        description: item.intro,
        details,
        meta_badges: metaBadges,
        image_badges: imageBadges,
        actions: [],
    };
}

export function agendaOnlineItemToCard(item: AgendaOnlineItem, t: Translate): UserHomeActivityCardData {
    const card = agendaItemToCard(item, t);
    if (item.videos_duration_label) {
        card.details = [
            ...(card.details ?? []),
            { icon: '🎬', text: item.videos_duration_label },
        ];
    }
    return card;
}
